import {WidgetDatasourceEnum} from "./widget-datasource.enum";
import {TagType} from "../../tags/angular/types/tag.type";

export const DataSourceQueryMapEnum = {
  [WidgetDatasourceEnum.servicesStatusTotals]: {},
  [WidgetDatasourceEnum.uniqueServiceFieldCount]: {},
  [WidgetDatasourceEnum.agentsStatusTotal]: {
    tagType: TagType.Agent
  },
  [WidgetDatasourceEnum.agentsTracking]: {
    tagType: TagType.Agent
  }
}
